<label class="toggle-switch">
	<input type="checkbox" [checked]="checked" (change)="toggle()">
	<span class="slider"></span>
</label>
